import { Drawer, DrawerContent } from '@finn/design-system/atoms/drawer';
import { useMediaQuery } from '@finn/design-system/helpers/media';
import { interactionTrackingEvent, TrackingEventName } from '@finn/ua-tracking';
import { useIntl } from '@finn/ui-utils';
import { useCallback, useContext } from 'react';

import { VehicleContext } from '../../product-cards';
import { EquipmentDetailsComponent } from './EquipmentDetailsComponent';
import { KeyData } from './KeyData';
import { VehicleHeader } from './VehicleHeader';

type Props = {
  open: boolean;
  onClose: () => void;
  productDetailsData: any;
};

export const CarInformationDrawer = ({
  open,
  onClose,
  productDetailsData,
}: Props) => {
  const i18n = useIntl();
  const isMDScreen = useMediaQuery('md');

  const handleModalClose = useCallback(() => {
    interactionTrackingEvent(TrackingEventName.MODAL_CLOSED, {
      name: 'carinfo',
    });
    onClose();
  }, [onClose]);

  const { vehicle } = useContext(VehicleContext);

  return (
    <Drawer
      open={open}
      onClose={handleModalClose}
      handleOnly
      direction={isMDScreen ? 'bottom' : 'right'}
    >
      <DrawerContent
        title={i18n.formatMessage('pdp.carInfo')}
        className="!select-text overflow-visible"
      >
        <VehicleHeader vehicle={vehicle} />
        <KeyData />
        <hr className="border-pearl w-full border-0 border-b border-solid" />
        <EquipmentDetailsComponent productDetailsData={productDetailsData} />
        <div className="pb-16" />
      </DrawerContent>
    </Drawer>
  );
};
